import React from "react";
import Container from "../../components/Container";
import ContentHeader from "../../components/ContentHeader";
import WithTechnologyOrbit from "./WithTechnologyOrbit";
import { IndustryExpertiseWapper, IndustryExpertiseTitle } from "./style";

const IndustryExpertise = () => {
  return (
    <IndustryExpertiseWapper>
      <Container>
        <IndustryExpertiseTitle>
          <h3>Industry Expertise</h3>
          <p>
            With 16 Years In This Industry, We Has The Chance To Work Across A
            Wide Range Of Industries And Continue To Build Our Portfolio Of
            Industry-Specific Solutions
          </p>
        </IndustryExpertiseTitle>
        <WithTechnologyOrbit />
      </Container>
    </IndustryExpertiseWapper>
  );
};
export default IndustryExpertise;
